import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectCustomer } from '../../../../customer/state/detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'

export default {
    taskName: taskName.PROVIDE_PHYSICIAN_RECOMMENDATION,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.ALIGNER_SEND_RECOMMENDATION_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.MEDICAL_PHOTO_CHECK_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
    taskValidatorSelector: [
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, customer) => {
        const messageList = []

        const treatmentExecutionList = customer.treatmentExecutionList
        const alignerCheckins = treatmentExecutionList[treatmentExecutionList.length - 1].alignerCheckInList
        const clarificationComment = alignerCheckins[alignerCheckins.length - 1].clarificationComment

        if (clarificationComment === null) {
            messageList.push(createValidationMessage('Please choose reason.', 'checkPhotoCheckin.reason'))

        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/provide_physician_recommendation.js